import React, { useCallback, ChangeEventHandler } from 'react';
import isNumber from 'lodash/isNumber';

import { I18nText } from '../../../../../types';

import { useTranslate } from '../../../../../common/hooks/useTranslate';

interface UniversalFilterPositiveIntegerInputProps {
  value: number;
  i18nPlaceholder?: I18nText;
  autoFocus?: boolean;
  onChange: (value?: number) => void;
}

function UniversalFilterPositiveIntegerInput({
  value,
  i18nPlaceholder,
  autoFocus,
  onChange
}: UniversalFilterPositiveIntegerInputProps) {
  const { t } = useTranslate();

  const handleChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
    (event) => {
      const parsedValue = parseInt(event.target.value);
      onChange(isFinite(parsedValue) ? parsedValue : null);
    },
    [onChange]
  );

  return (
    <div className="flex-1">
      <div className="relative">
        <input
          className="basic-input"
          min={0}
          placeholder={i18nPlaceholder ? t(i18nPlaceholder) : undefined}
          type="text"
          value={isNumber(value) ? value : ''}
          autoFocus={autoFocus}
          onChange={handleChange}
        />
      </div>
    </div>
  );
}

export default UniversalFilterPositiveIntegerInput;
